import { getToken as firebaseGetToken, isSupported } from 'firebase/messaging';
import { messaging } from '../firebase';

export async function registerAndGetToken(vapidKey) {
  // Check if messaging is supported
  const supported = await isSupported();
  if (!supported) {
    console.warn('[FCM] Firebase Messaging not supported in this browser');
    throw new Error('notifications-not-supported');
  }

  if (typeof Notification === 'undefined') {
    throw new Error('notifications-not-supported');
  }

  if (Notification.permission === 'denied') {
    throw new Error('permission-blocked');
  }

  // Request permission if default
  if (Notification.permission === 'default') {
    const p = await Notification.requestPermission();
    if (p !== 'granted') throw new Error('permission-not-granted');
  }

  // Let Firebase handle service worker registration automatically
  // Do NOT manually register - it conflicts with Firebase's internal SW management
  try {
    const token = await firebaseGetToken(messaging, { vapidKey });
    console.log('[FCM] ✅ Token obtained:', token ? token.substring(0, 20) + '...' : 'null');
    return token;
  } catch (err) {
    console.error('[FCM] ❌ Token retrieval failed:', err);
    throw err;
  }
}

export default { registerAndGetToken };
